import { useQuery } from '@tanstack/react-query'

import {
  URL as VEHICLE_EVENTS_TABLE_URL,
  VEHICLE_EVENTS_GROUPS,
} from '@/hooks/useGetVehicleEventsTable'

import { useLegacyAuthApi, useLegacyPublicApi } from '@/services/api/ApiContext'

import { SERVICE_BOOKING_TABLES_CANCEL_REASONS_PATH } from '@/services'

export const useGetServiceBookingCancelReasons = (
  tokenId,
  isVehicleEvents = false,
  config = {},
) => {
  const authApi = useLegacyAuthApi()
  const publicApi = useLegacyPublicApi()

  const api = isVehicleEvents ? authApi : publicApi

  return useQuery({
    queryKey: [
      'get-table-service-booking-cancel-reasons',
      tokenId,
      isVehicleEvents ? '1' : '0',
    ],
    queryFn: async () => {
      if (!api || (!tokenId && !isVehicleEvents)) {
        return false
      }
      const url = isVehicleEvents
        ? VEHICLE_EVENTS_TABLE_URL.replace(
            '{groupName}',
            VEHICLE_EVENTS_GROUPS.cancelReasons,
          )
        : SERVICE_BOOKING_TABLES_CANCEL_REASONS_PATH.replace(
            '{tokenId}',
            tokenId,
          )
      const { data } = await api.get(url)
      return data
    },
    ...config,
  })
}
